import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ApplicationService } from '../services/application.service'
import { Router, ActivatedRoute } from '@angular/router';
import { PartnerService } from '../services/partner.service';
import { Observable } from 'rxjs/Observable';
@Component({
  selector: 'app-topstats',
  templateUrl: './topstats.component.html',
  styleUrls: ['./topstats.component.css']
})
export class TopstatsComponent implements OnInit {
  statusMessage: string = "Loading data please wait...";
  userDetails: any;
  constructor(private _applicationService: ApplicationService, private router: Router, private _partnerService: PartnerService, private cdRef: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.getPartnerDashboardDetails();
  }

  getPartnerDashboardDetails()
  {
    debugger;
    this._partnerService.getPartnerDashboardDetails()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.userDetails = employeeData.response.userdetails; 
            // this.userDetails.femalePatient = employeeData.response.userdetails.femalePatients; 
            // this.userDetails.malePatient = employeeData.response.userdetails.malePatients; 
          }         
         console.log(this.userDetails)
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }
 
      );
  }

}
